import { useAppSelector } from 'app/hooks';

import {
  computeNeedsFlags,
  computeProgressPercent,
  getTtsServiceAccountEmail,
  pickActiveOnboardingStep,
  resolveChecklistCompletion
} from 'features/tts-onboarding/utils/tts-onboarding-utils';

export default function useTTSOnboarding() {
  const { merchant, ttsPermissionsGranted, tiktokPlan } = useAppSelector((store) => store.merchant);

  const hidePlans = Boolean(merchant?.hidePlans);
  const hasMerchant = Boolean(merchant);
  const hasPaymentMethod = Boolean(merchant?.defaultPaymentMethod?.id);

  const checklist = resolveChecklistCompletion({
    hidePlans,
    hasPaymentMethod,
    tiktokPlan,
    ttsPermissionsGranted
  });

  const { needsPayment, needsPlan, needsPermissions } = computeNeedsFlags(hasMerchant, hidePlans, checklist);

  const isVisible = Boolean(merchant && (needsPermissions || needsPlan || needsPayment));

  const progressPercent = computeProgressPercent(hidePlans, checklist, needsPlan, needsPayment);

  const activeOnboardingStep = hasMerchant ? pickActiveOnboardingStep(needsPlan, needsPayment, needsPermissions) : null;

  const ttsEmail = getTtsServiceAccountEmail(merchant?.name);

  return {
    activeOnboardingStep,
    isVisible,
    needsPayment,
    needsPlan,
    needsPermissions,
    progressPercent,
    ttsEmail
  };
}
